<bp-set-security-questions-answers-form
	class="h-100"
	[allSecurityQuestions]="identityFacade.allSecurityQuestions$ | async"
	[pending]="introFacade.pending$ | async"
	[error]="introFacade.error$ | async"
	(submitted)="identityFacade.setSecurityQuestionsAnswers($event)"
	(login)="introFacade.gotoLoginPage()"
>
</bp-set-security-questions-answers-form>
